module.exports = require("@mui/icons-material/Satellite");